var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "save-wrapper-component",
    {
      ref: "saveWraperRef",
      attrs: {
        "max-width": "1200px",
        name: _vm.name,
        title: _vm.$t("Dialogs.BackupSettings.Title"),
        scrollable: false,
      },
    },
    [
      _c("div", { staticClass: "d-flex backup-settings-dialog" }, [
        _c(
          "div",
          { staticClass: "flex-shrink-0 overflow-auto min-width-250" },
          [
            _c(
              "v-tabs",
              {
                staticClass: "my-tabs height-100x",
                attrs: { vertical: "" },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _c(
                  "v-tab",
                  {
                    attrs: {
                      "tab-value": "settings",
                      href: "#settings",
                      "active-class": "side-tab-active",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Dialogs.BackupSettings.Settings")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "v-tab",
                  {
                    attrs: {
                      "tab-value": "history",
                      href: "#history",
                      "active-class": "side-tab-active",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Dialogs.BackupSettings.History")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "v-tab",
                  {
                    attrs: {
                      "tab-value": "restore",
                      href: "#restore",
                      "active-class": "side-tab-active",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Dialogs.BackupSettings.Restore")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "height-100x d-flex flex-column flex-grow-1 px-3 overflow-hidden",
          },
          [
            _c(
              "div",
              { staticClass: "overflow-auto" },
              [
                _c(
                  "v-tabs-items",
                  {
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  [
                    _c(
                      "v-tab-item",
                      { attrs: { value: "settings" } },
                      [
                        _c("backup-settings-form-component", {
                          ref: "backupSettingsForm",
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "history" } },
                      [
                        _c("backup-history-component", {
                          ref: "backupHistory",
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "restore" } },
                      [
                        _c("backup-restore-component", {
                          ref: "backupRestore",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }